/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2017
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define('collaboration/nls/StringResources',['i18n!./CollaborationResources', 'polyglot'], function (collaborationResources, Polyglot) {

	var poly = new Polyglot({
		phrases: collaborationResources,
		allowMissing: true
	});

	var StringResources = function StringResources() {
		// constructor
	};

	/**
  * Get the string resource for the given key and interpolation options. Checks the Storytelling resources first and if
  * not found it checks the Dashboard resources.
  *
  * @param key						The  key of the string to return
  * @param interpolationOptions		Optional interpolation options (see poly.t documentation for details)
  * @returns							The string to display
  */
	StringResources.prototype.get = function (key, interpolationOptions) {
		return poly.t(key, interpolationOptions);
	};

	return new StringResources();
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

